import React from "react";
import { Layout } from "antd";
import WebsiteIndexEntryTabs from "../../deepAnalysis/websiteIndexEntry/WebsiteIndexEntryTabs";
import TopKeywords from "../TopKeywords";


export default function TopKeywordsPage() {
    return (
        <Layout.Content className="general-layout-content">
            <WebsiteIndexEntryTabs>
                <TopKeywords />
            </WebsiteIndexEntryTabs>
        </Layout.Content>
    );
}
